import {
  useUserStore,
  userStoreSelector,
} from '@repo/editor/src/stores/userStore';
import { fireToast } from '@repo/ui/components/Toast';

export const useBookmarks = () => {
  const bookmarks = useUserStore(userStoreSelector.bookmarks);
  const user = useUserStore(userStoreSelector.user);

  const isBookmarked = (templateId: string) => bookmarks.includes(templateId);

  const toggleBookmark = (templateId: string, featureOrigin = 'website') => {
    if (!user) {
      fireToast({ label: 'Please log in to bookmark this post' });
      return;
    }

    const currentlyBookmarked = isBookmarked(templateId);

    useUserStore
      .getState()
      .updateBookmark(currentlyBookmarked, templateId, featureOrigin);

    fireToast({
      label: `${currentlyBookmarked ? 'Removed from' : 'Saved to'} Bookmarks`,
    });
  };

  return {
    isBookmarked,
    toggleBookmark,
  };
};
